import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { getData } from "features/dinamic";


interface CentroState {
    status: string;
    error: string;
    centroList: any[],
    centroListActive: any[],
    centro: {
        idTipoCentro: number | null;
        nombre: string | null;
    }

}

const initialState: CentroState = {
    status: 'idle',
    error: '',
    centroList: [],
    centroListActive: [],
    centro: {
        idTipoCentro: null,
        nombre: null
    }
}

export const fetchCentro = createAsyncThunk('fetchCentro', async (_: any, { dispatch,getState, rejectWithValue }) => {
    const idsp = 47;
    const { result, message, data } = await getData({  idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchCentroActive = createAsyncThunk('fetchCentroActive', async (_: any, { dispatch,getState, rejectWithValue }) => {
    const idsp = 48;
    const { result, message, data } = await getData({  idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const centroSlice = createSlice({
    name: 'centro',
    initialState,
    reducers: {
        setCentroList: (state, action) => {
            state.centroList = action.payload;
        },
        setCentroListActive: (state, action) => {
            state.centroListActive = action.payload;
        },
        setCentro: (state, action) => {
            state.centro = !action.payload ? initialState.centro : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchCentro.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCentro.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.centroList = data? data : [];

            })
            .addCase(fetchCentro.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchCentroActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCentroActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.centroListActive = data? data : [];

            })
            .addCase(fetchCentroActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectCentroList = (state: RootState) => state.centro.centroList;
export const selectCentroListActive = (state: RootState) => state.centro.centroListActive;
export const selectCentro = (state: RootState) => state.centro.centro;

export const { setCentroList, setCentroListActive, setCentro } = centroSlice.actions;

export default centroSlice.reducer;



